import React, { } from "react";
import { Row, Col, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { PlusCircle } from 'react-bootstrap-icons';
import QuestionOptSingle from './QuestionOptSingle';
import QuestionOptMultiple from './QuestionOptMultiple';
import QuestionOptOpen from './QuestionOptOpen';
import QuestionOptRuler from './QuestionOptRuler';
import QuestionOptArray from './QuestionOptArray';
// import { render } from "@testing-library/react";
import { useMappedState, useDispatch } from 'redux-react-hook';
import Enums from '../../../enums';

export default function Question(props) {
    const tmpItems = useMappedState(state => state.tmpItems);
    const questionIndex = props.index;
    const data = tmpItems[questionIndex];
    const q_type = (data && data.cf) ? data.cf.q_type : null;
    const dispatch = useDispatch();


    function onOptDelete(optIndex) {
        console.log("onOptDelete", optIndex)
        // props.onOptDelete(props.index, optIndex);

        let tmp = [...tmpItems];
        tmp[questionIndex].op.splice(optIndex, 1);

        //update random options
        try {
            if (tmp[questionIndex].cf.parameters.random.is_rand == 1) {
                for (let j = 0; j < tmp[questionIndex].cf.parameters.random.rand.length;) {
                    for (let i = 0; i < tmp[questionIndex].cf.parameters.random.rand[j].length;) {
                        if (tmp[questionIndex].cf.parameters.random.rand[j][i] == optIndex) {
                            tmp[questionIndex].cf.parameters.random.rand[j].splice(i, 1);
                        }
                        else {
                            if (tmp[questionIndex].cf.parameters.random.rand[j][i] > optIndex) {
                                tmp[questionIndex].cf.parameters.random.rand[j][i] = tmp[questionIndex].cf.parameters.random.rand[j][i] - 1;
                            }
                            i++
                        }
                    }
                    //remove the option set if there's only 0~1 option
                    if (1 >= tmp[questionIndex].cf.parameters.random.rand[j].length) {
                        // if (1 == tmp[questionIndex].cf.parameters.random.rand[j].length) {
                        // } else {

                        // }
                        alert("因題號刪除移除隨機組別" + (j + 1))
                        tmp[questionIndex].cf.parameters.random.rand.splice(j, 1);
                    } else {
                        // if (1 == tmp[questionIndex].cf.parameters.random.rand[j].length) {

                        //     tmp[questionIndex].cf.parameters.random.rand[j].push(tmp[questionIndex].cf.parameters.random.rand[j][0]);
                        // }
                        j++
                    }
                }
                //reset to not random if no option sets
                if (0 == tmp[questionIndex].cf.parameters.random.rand.length) {
                    tmp[questionIndex].cf.parameters.random.is_rand = 0;
                }
            }
        } catch (e) {
            console.log(e);
        }
        // setTmpItems(tmp);
        dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
    }

    function onOptAdd() {
        // console.log("onOptAdd")
        // props.onOptAdd(props.index);

        let tmp = [...tmpItems];
        // console.log(tmp, questionIndex, tmpItems);
        tmp[questionIndex].op.push({ na: "name", o_type: 0 });

        //special rule dealing
        switch (q_type) {
            case Enums.E_QUESTION_TYPE_INDEX.ARRAY:
                //API目前沒有提供單多選, 須設定右列固定值 limit={min:1,max:1}, group=[], row_type=1
                tmp[questionIndex].op[tmp[questionIndex].op.length - 1].group = [];
                tmp[questionIndex].op[tmp[questionIndex].op.length - 1].limit = { min: 1, max: 1 };
                break;
        }
        if (tmp[questionIndex].ru.route.ty == 1) {
            tmp[questionIndex].ru.route.ta.push(questionIndex + 2);
        }
        // setTmpItems(tmp);
        dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
    }

    function render() {
        if (null == data || null == q_type) {
            return <div>No Data</div>
        }

        let tmp = [];

        if (Enums.E_QUESTION_TYPE_INDEX.OPEN == q_type) {
            data.op.forEach(function (value, index) {
                tmp.push(<QuestionOptOpen
                    key={questionIndex + "-" + index}
                    questionID={questionIndex}
                    optIndex={index}
                    // data={value}
                    // onChange={(val) => { console.log("onChange", val); onOptChange(index, val) }}
                    onDelete={() => { onOptDelete(index) }}
                />);
            });
        } else if (Enums.E_QUESTION_TYPE_INDEX.RULER == q_type) {
            data.op.forEach(function (value, index) {
                tmp.push(<QuestionOptRuler
                    key={questionIndex + "-" + index}
                    questionID={questionIndex}
                    optIndex={index}
                    // data={value}
                    // onChange={(val) => { console.log("onChange", val); onOptChange(index, val) }}
                    onDelete={() => { onOptDelete(index) }}
                />);
            });
        } else if (Enums.E_QUESTION_TYPE_INDEX.ARRAY == q_type) {
            data.op.forEach(function (value, index) {
                tmp.push(<QuestionOptArray
                    key={questionIndex + "-" + index}
                    questionID={questionIndex}
                    optIndex={index}
                    // data={value}
                    // onChange={(val) => { console.log("onChange", val); onOptChange(index, val) }}
                    onDelete={() => { onOptDelete(index) }}
                />);
            });

            tmp.push(<Row key={1}>
                <Col className="text-left">
                    <OverlayTrigger
                        key={"step2"}
                        placement="top"
                        overlay={
                            <Tooltip id={`tooltip-step2`}>新增其他選項</Tooltip>
                        }
                    >
                        <PlusCircle onClick={onOptAdd} className="point-cursor" />
                    </OverlayTrigger>
                </Col>
            </Row>)
        } else {
            data.op.forEach(function (value, index) {
                tmp.push(<QuestionOptSingle
                    key={questionIndex + "-" + index}
                    questionID={questionIndex}
                    optIndex={index}
                    // data={value}
                    // onChange={(val) => { console.log("onChange", val); onOptChange(index, val) }}
                    onDelete={() => { onOptDelete(index) }}
                />);
            });

            tmp.push(<Row key={1}>
                <Col className="text-left">
                    <OverlayTrigger
                        key={"step2"}
                        placement="top"
                        overlay={
                            <Tooltip id={`tooltip-step2`}>新增其他選項</Tooltip>
                        }
                    >
                        <PlusCircle onClick={onOptAdd} className="point-cursor" />
                    </OverlayTrigger>
                </Col>
            </Row>)
        }


        // switch (q_type) {
        //     case 1: //單選
        //     case 3: //下拉
        //         data.op.forEach(function (value, index) {
        //             // console.log(value);
        //             tmp.push(<QuestionOptSingle
        //                 key={questionIndex + "-" + index}
        //                 questionID={questionIndex}
        //                 optIndex={index}
        //                 // data={value}
        //                 // onChange={(val) => { console.log("onChange", val); onOptChange(index, val) }}
        //                 onDelete={() => { onOptDelete(index) }}
        //             />);
        //         });
        //         tmp.push(<Row key={1}>
        //             <Col className="text-left">
        //                 <PlusCircle onClick={onOptAdd} className="point-cursor" />
        //             </Col>
        //         </Row>)
        //         break;
        //     case 2: //多選
        //         data.op.forEach(function (value, index) {
        //             // console.log(value);
        //             tmp.push(<QuestionOptMultiple
        //                 key={questionIndex + "-" + index}
        //                 questionID={questionIndex}
        //                 optIndex={index}
        //                 onDelete={() => { onOptDelete(index) }}
        //             // data={value}
        //             // onChange={(val) => { console.log("onChange", val); onOptChange(index, val) }}
        //             // onDelete={() => { onOptDelete(index) }}
        //             />);
        //         });
        //         tmp.push(<Row key={1}>
        //             <Col className="text-left">
        //                 <PlusCircle onClick={onOptAdd} className="point-cursor" />
        //             </Col>
        //         </Row>)
        //         break;
        //     case 4: //開放
        //         data.op.forEach(function (value, index) {
        //             // console.log(value);
        //             tmp.push(<QuestionOptOpen
        //                 key={questionIndex + "-" + index}
        //                 questionID={questionIndex}
        //                 optIndex={index}
        //                 onDelete={() => { onOptDelete(index) }}
        //             // data={value}
        //             // onChange={(val) => { console.log("onChange", val); onOptChange(index, val) }}
        //             // onDelete={() => { onOptDelete(index) }}
        //             />);
        //         });
        //         tmp.push(<Row key={1}>
        //             <Col className="text-left">
        //                 <PlusCircle onClick={onOptAdd} className="point-cursor" />
        //             </Col>
        //         </Row>)
        //         break;
        //     default:
        //         tmp = (<div>未知或未完成的問題類型</div>);
        //         break;
        // }

        return (
            <>
                {/* <Row>
                    <Col>題目{data.id}</Col>
                </Row> */}
                {tmp}
                {/* <Row>
                    <Col className="text-left">
                        <PlusCircle onClick={this.props.onOptAdd} className="point-cursor" />
                    </Col>
                </Row> */}
            </>
        );
    }
    return render();
}